// extracted by mini-css-extract-plugin
module.exports = {"siteCertifications":"SiteCertifications_siteCertifications__B5LAE","content":"SiteCertifications_content__cfSqP","row":"SiteCertifications_row__CFzni"};